module.exports = __webpack_public_path__ + "img/photo_2024-04-07_18-27-03.3d0c101c.jpg";